import {
    MetadataClassifierField,
    MetadataType,
} from "models/MetadataClassifierField";
import { useEffect, useState } from "react";
import QuestionMetadataService from "services/QuestionMetadataService";

const useExtendedMetadataFields = (orgId: string) => {
    const [fields, setFields] = useState<MetadataClassifierField[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    // Only true after a successful fetch, so an empty list can be trusted.
    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(() => {
        if (!orgId) {
            return;
        }
        let destroyed = false;
        const runFn = async () => {
            try {
                setIsLoading(true);
                const res =
                    await new QuestionMetadataService().getAvailableMetadataClassifierFields(
                        orgId,
                    );
                if (!destroyed) {
                    setFields(
                        res
                            .filter(
                                (field) =>
                                    field.type === MetadataType.Extended,
                            )
                            .sort((a, b) => a.label.localeCompare(b.label)),
                    );
                    setHasLoaded(true);
                    setIsLoading(false);
                }
            } catch (err) {
                console.error(err);
                setIsLoading(false);
            }
        };
        runFn();
        return () => {
            destroyed = true;
            setFields([]);
            setHasLoaded(false);
        };
    }, [orgId]);

    return {
        fields,
        isLoading,
        hasLoaded,
    };
};

export default useExtendedMetadataFields;
